<template>
    <section id="faq" class="sp-section sp-section--alt sp-faq-section">
        <!-- Orbe de luz ambiental -->
        <div class="sp-glow-orb sp-glow-orb--navy" style="bottom: 10%; right: -5%; width: 400px; height: 400px;"></div>

        <div class="sp-container sp-faq">
            <div class="sp-section-head sp-reveal">
                <span class="sp-eyebrow">Preguntas frecuentes</span>
                <h2 class="sp-h2">Resolvemos todas tus dudas antes de empezar</h2>
                <p class="sp-lead">
                    Todo lo que necesitas saber sobre cómo funciona la publicidad para conductores en ruta con Seway Plus.
                </p>
            </div>

            <Accordion class="sp-faq__acordeon sp-reveal sp-delay-2" @click="alClicEnRespuesta">
                <AccordionTab v-for="item in preguntas" :key="item.p" :header="item.p">
                    <p v-html="item.r"></p>
                </AccordionTab>
            </Accordion>
        </div>
    </section>
</template>

<script>
import { irASeccion } from '../navegacion';

export default {
    name: 'NegociosFaq',
    methods: {
        alClicEnRespuesta(evento) {
            const enlace = evento.target.closest('[data-ir]');
            if (!enlace) return;
            evento.preventDefault();
            irASeccion(enlace.getAttribute('data-ir'));
        }
    },
    data() {
        return {
            preguntas: [
                {
                    p: '¿Qué es Seway Plus Negocios?',
                    r: 'Es el servicio de publicidad de Seway Plus para comercios y servicios que atienden al conductor de carga pesada. Tu oferta se muestra dentro de la aplicación móvil que usan los conductores durante sus viajes, asociada a la geocerca de tu establecimiento.'
                },
                {
                    p: '¿Qué tipo de negocios pueden anunciarse?',
                    r: 'Restaurantes, paradores de carretera, hoteles y sitios de descanso, montallantas, servitecas y talleres mecánicos, estaciones de combustible, parqueaderos vigilados y cualquier comercio que resuelva una necesidad en ruta.'
                },
                {
                    p: '¿Cómo sabe la aplicación que mi negocio está cerca del conductor?',
                    r: 'Seway define el área de cobertura inteligente de cada sede al activarla, tomando en cuenta su ubicación exacta y las vías principales por donde circulan los camiones. <strong>El comercio no tiene que configurar coordenadas complejas</strong>: garantizamos que la oferta aparezca en el momento útil y seguro del viaje.'
                },
                {
                    p: '¿Qué puedo publicar en mi oferta?',
                    r: 'Puedes configurar tu oferta con fotos de alta calidad, descripción clara, porcentaje de descuento o combo, horarios de atención 24/7 y la duración de la campaña.'
                },
                {
                    p: '¿Cuánto cuesta anunciarse?',
                    r: 'El cobro es transparente por día de campaña y depende del plan y nivel de visibilidad que elijas. Puedes consultar los valores vigentes en la sección <a href="#" data-ir="planes">Planes</a> de esta página.'
                },
                {
                    p: '¿Puedo pausar o modificar mi campaña en cualquier momento?',
                    r: 'Sí. Desde tu panel de control de anunciante puedes actualizar los textos de tu oferta, modificar fotos, activar o pausar campañas cuando lo consideres necesario.'
                },
                {
                    p: '¿Qué información y métricas recibo de los conductores?',
                    r: 'Únicamente <strong>métricas agregadas, anónimas y de rendimiento</strong> (impresiones, clics e intención de visita). Seway Plus <strong>no comparte datos personales ni la ubicación individual de ningún conductor</strong>, cumpliendo estrictamente la Ley 1581 de 2012 de Habeas Data.'
                },
                {
                    p: '¿Cómo puedo empezar hoy mismo?',
                    r: 'Crea tu cuenta de anunciante, registra tu negocio y activa tu primera campaña. Si prefieres acompañamiento personalizado, déjanos tus datos en la sección de contacto y un asesor comercial te guiará paso a paso.'
                }
            ]
        };
    }
};
</script>

<style lang="scss" scoped>
.sp-faq-section {
    position: relative;
    overflow: hidden;
}

.sp-faq {
    max-width: 920px;

    /* En monitores grandes 920px dentro de un contenedor de 1760px se veia
       como una columna estrecha flotando en el centro. */
    @media (min-width: 2000px) {
        max-width: 1120px;
    }
}

.sp-faq__acordeon {
    :deep(.p-accordion-tab) {
        margin-bottom: 1rem;
        box-shadow: 0 4px 16px rgba(13, 48, 68, 0.05);
        border-radius: 14px;
        overflow: hidden;
        transition: box-shadow 0.25s ease, transform 0.25s ease;

        &:hover {
            box-shadow: 0 8px 24px rgba(13, 48, 68, 0.1);
        }
    }

    :deep(.p-accordion-header-link) {
        gap: 1rem;
        padding: 1.25rem 1.5rem;
        background: #ffffff;
        border: 1px solid var(--sp-border);
        border-radius: 14px;
        color: var(--sp-navy);
        font-size: clamp(0.98rem, 1.4vw, 1.1rem);
        font-weight: 700;
        line-height: 1.45;
        white-space: normal;
        text-align: left;
        transition: all 0.25s ease;
    }

    :deep(.p-accordion-header-link:focus) {
        box-shadow: 0 0 0 3px rgba(235, 93, 27, 0.35);
    }

    :deep(.p-accordion-header:not(.p-disabled).p-highlight .p-accordion-header-link) {
        background: linear-gradient(135deg, var(--sp-navy) 0%, var(--sp-navy-800) 100%);
        border-color: var(--sp-navy);
        border-radius: 14px 14px 0 0;
        color: #ffffff;
        box-shadow: 0 4px 14px rgba(13, 48, 68, 0.2);
    }

    :deep(.p-accordion-header-link .p-accordion-toggle-icon) {
        flex: 0 0 auto;
        color: var(--sp-orange);
        font-size: 1.1rem;
        transition: transform 0.25s ease;
    }

    :deep(.p-accordion-content) {
        padding: 1.4rem 1.5rem;
        background: #ffffff;
        border: 1px solid var(--sp-border);
        border-top: 0;
        border-radius: 0 0 14px 14px;
        color: var(--sp-text-soft);
        font-size: 0.98rem;
        line-height: 1.75;
    }

    :deep(.p-accordion-content a) {
        color: var(--sp-orange);
        font-weight: 700;
        text-decoration: underline;
        text-underline-offset: 3px;

        &:hover {
            color: var(--sp-orange-600);
        }
    }

    :deep(.p-accordion-content strong) {
        color: var(--sp-navy);
    }
}
</style>
